import {Box, Stack, Switch} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import InfoTooltip from "../../common/InfoTooltip";

interface Props {
    checked: boolean
    onChange: (checked: boolean) => void
    label: string
    /** The glyph this flag draws elsewhere - the author meets it here, where the flag is set. */
    icon?: React.ReactNode
    tooltip?: string
    disabled?: boolean
}

/** One switch of the question settings panel; the Visibility section's switch reads the same way. */
export function SwitchRow({checked, onChange, label, icon, tooltip, disabled}: Props) {
    return (
        <Stack direction={'row'} alignItems={'center'}>
            <Switch
                checked={checked}
                disabled={disabled}
                onChange={(event) => onChange(event.target.checked)}
            />
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                {/* Fixed slot: the asterisk is narrower than the lock, and without it the two
                    labels would start at different offsets. */}
                {!!icon && (
                    <Box sx={{display: 'flex', justifyContent: 'center', width: 16, mr: 0.75}}>
                        {icon}
                    </Box>
                )}
                <Typography variant={'body2'} component={'span'}>
                    {label}
                </Typography>
                {!!tooltip && <InfoTooltip title={tooltip}/>}
            </Box>
        </Stack>
    );
}
